import { Typography, TypographyProps } from '@material-ui/core'
import React from 'react'

import { IFaq } from '@aletheia/eafunds/contentful/types/generated'

import Markdown from '../Markdown'

type FAQEntryEAFundsProps = {
  FAQEntry: IFaq
  headingVariant?: TypographyProps['variant']
  headingComponent?: React.ElementType
  noTags?: boolean
  noAnchor?: boolean
}

export const FAQEntryEAFunds: React.FC<
  FAQEntryEAFundsProps & React.HTMLAttributes<HTMLDivElement>
> = ({
  FAQEntry,
  // noTags = false,
  // noAnchor = false,
  headingVariant = 'h5',
  headingComponent = 'h5',
  className,
}) => {
  const { title, body } = FAQEntry.fields
  return (
    <div className={className}>
      <Typography
        variant={headingVariant}
        component={headingComponent}
        gutterBottom
      >
        {title}
      </Typography>
      <Markdown>{body}</Markdown>
    </div>
  )
}
